module.exports = __webpack_public_path__ + "img/thumb-bananenmuffins.e546a4f8.jpeg";